import { render } from "./new-featured-vertical-img.vue?vue&type=template&id=924482bc&scoped=true&lang=html"
import script from "./new-featured-vertical-img.vue?vue&type=script&lang=js"
export * from "./new-featured-vertical-img.vue?vue&type=script&lang=js"

import "./new-featured-vertical-img.vue?vue&type=style&index=0&id=924482bc&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924482bc"]])

export default __exports__